import { createApp } from 'vue'
import App from './App.vue'
import install from './install'
import './permission'
import './styles/index.scss'
import 'virtual:svg-icons-register'
import findItem from '@/components/find/find-item/index.vue'
import ipItem from '@/components/find/ip-item/index.vue'

const app = createApp(App)

app.component('findItem', findItem)
app.component('ipItem', ipItem)
app.use(install)
app.mount('#app')
